import { Actividad } from "../Actividad/Actividad";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import {
  actividadesNoValidadas,
  actividadesPublicadas,
} from "./Actividades-Api";
import { isEmpty } from "../../util/Functions";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { getUserLoggedLS } from "../../util/LocalStorageUtils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function Pdtesvalidar({ setTitulo }) {
  const [actividades, setActividades] = useState(null);
  const navigate = useNavigate();
  setTitulo("Pdtes. validar");

  useEffect(() => {
    refrescarActividades();
  }, []);

  const fabStyle = {
    position: "fixed",
    bottom: 32,
    right: 32,
  };

  const refrescarActividades = () => {
    var userLogged = getUserLoggedLS();
    if (!isEmpty(userLogged)) {
      actividadesNoValidadas(setActividades, userLogged);
    } else {
      // NO LOGADO
      actividadesPublicadas(setActividades);
    }
  };

  const notificarCambio = (msg) => {
    toast.warning(msg);
  };

  const handleNew = () => {
    setTitulo("Nueva actividad");
    navigate("/newactividad/");
  };

  return (
    <>
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Grid container spacing={2}>
        {actividades != null
          ? actividades.map((actividad) => (
              <Grid key={actividad.id} item xs={12} sm={6} md={4}>
                <Actividad
                  act={actividad}
                  setTitulo={setTitulo}
                  refrescar={refrescarActividades}
                  notificar={notificarCambio}
                ></Actividad>
              </Grid>
            ))
          : "no hay actividades"}
      </Grid>
      <Fab
        sx={fabStyle}
        color="primary"
        aria-label="add"
        onClick={() => handleNew()}
      >
        <AddIcon />
      </Fab>
    </>
  );
}
